import { render, staticRenderFns } from "./MemoCell.vue?vue&type=template&id=e913329a&scoped=true"
import script from "./MemoCell.vue?vue&type=script&lang=js"
export * from "./MemoCell.vue?vue&type=script&lang=js"
import style0 from "./MemoCell.vue?vue&type=style&index=0&id=e913329a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e913329a",
  null
  
)

export default component.exports